import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["amount", "toggleWrapper"]

  connect() {
    this.update()
  }

  update() {
    const value = parseFloat(this.amountTarget.value)
    const hasDeposit = value > 0

    this.toggleWrapperTarget.classList.toggle("opacity-40", !hasDeposit)
    this.toggleWrapperTarget.classList.toggle("pointer-events-none", !hasDeposit)
  }
}
